import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { INFO_PAGES } from "@/data/pages";

const Block = ({ block }) => {
  switch (block.type) {
    case "subheading":
      return <h2 className="font-serif text-2xl text-charcoal mt-9 mb-3">{block.text}</h2>;
    case "para":
      return <p className="text-gray-600 leading-relaxed mb-4">{block.text}</p>;
    case "list":
      return (
        <ul className="space-y-2.5 mb-4">
          {block.items.map((it, i) => (
            <li key={i} className="flex gap-3 text-gray-600 leading-relaxed">
              <span className="text-metallic-gold mt-1">◆</span> <span>{it}</span>
            </li>
          ))}
        </ul>
      );
    case "cta":
      return (
        <Link
          to={block.to}
          className="inline-block mt-3 bg-pink text-white px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors"
        >
          {block.label}
        </Link>
      );
    case "table":
      return (
        <div className="overflow-x-auto my-6 border border-gray-100">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-surface">
                {block.headers.map((h) => (
                  <th key={h} className="text-left px-4 py-3 uppercase tracking-wide text-xs text-charcoal font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, i) => (
                <tr key={i} className="border-t border-gray-100">
                  {row.map((c, j) => (
                    <td key={j} className="px-4 py-3 text-gray-600">{c}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    case "faq":
      return (
        <div className="divide-y divide-gray-100 border-t border-gray-100 mt-4">
          {block.items.map((f, i) => (
            <div key={i} className="py-5">
              <h3 className="font-serif text-xl text-charcoal">{f.q}</h3>
              <p className="text-gray-600 leading-relaxed mt-2">{f.a}</p>
            </div>
          ))}
        </div>
      );
    default:
      return null;
  }
};

export default function InfoPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "");
  const page = INFO_PAGES[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-28 text-center" data-testid="info-page-notfound">
        <h1 className="font-serif text-4xl text-charcoal">Page Not Found</h1>
        <Link to="/" className="inline-block mt-8 bg-pink text-white px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">Back Home</Link>
      </div>
    );
  }

  return (
    <div data-testid={`info-page-${slug}`}>
      <div className="bg-surface py-14 text-center">
        <p className="text-xs uppercase tracking-[0.28em] text-pink">Zebaa</p>
        <h1 className="font-serif text-5xl lg:text-6xl mt-3 text-charcoal">{page.title}</h1>
        <p className="text-gray-500 mt-3">{page.intro}</p>
        <div className="w-16 h-px bg-gold mx-auto mt-6" />
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {page.blocks.map((b, i) => <Block key={i} block={b} />)}
      </div>
    </div>
  );
}
